import { useQuery } from '../use-query';
import { notificationsService } from '../../../services';
import { showToRoles } from '../../../utils';

export const useNotificationsQuery = ({ user, ...keys }: any = {}) => {
  return useQuery(
    ['notifications', JSON.stringify(keys)],
    () => {
      if (!showToRoles(['SUPER_ADMIN'], user)) {
        return Promise.resolve({ data: [], totalCount: 0 });
      }

      return notificationsService
        .getAll({ params: { ...keys, notLoading: true } })
        .then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};
